export const en = {
  lastRefreshed: 'Last updated',
  refreshData: 'Refresh Data',
  refreshingData: 'Refreshing...',
  notRefreshed: 'Not updated',
  refreshedSuccessfully: 'Data refreshed successfully',
  refreshFailed: 'Refresh failed',
  errorOccurred: 'Error Occurred',
  failedToLoadData: 'Failed to load data',
  notAvailable: 'Not Available',
  noSignedCharterAvailable: 'There is no signed charter available.',
  downloaded: 'Downloaded',
  charterDownloadedSuccessfully: 'Partnership charter downloaded successfully.',
  error: 'Error',
  failedToDownloadCharter: 'Failed to download charter. Please try again later.',
  failedToDownloadAttachment: 'Failed to download attachment. Please try again later.',
  fileDownloadedSuccessfully: 'File downloaded successfully.',
  actions: 'Actions',
  studentActions: 'Student Actions',
  updateInfo: 'Update Info',
  studentDocuments: 'Student Documents',
  signCharter: 'Sign Charter',
  downloadCharter: 'Download Charter',
  myApplicationsTitle: 'My Applications',
  allChildrenApplications: "All your children's applications",
  totalApplications: 'Total Applications',
  inProgress: 'In Progress',
  accepted: 'Accepted',
  returned: 'Returned',
  modified: 'Modified',
  rejected: 'Rejected',
  unknown: 'Unknown',
  application: 'Application',
  applicationType: 'Application Type',
  dataUpdateApplication: 'Data update application',
  documentUpdateApplication: 'Document update application',
  studentNumber: 'Student Number',
  eid: 'EID',
  comment: 'Comment',
  approved: 'Approved',
  noApplicationsFound: 'No applications found',
  noApplicationsRegistered: 'No applications registered at the moment',
  noStudentsFound: 'No Students Found',
  noLinkedStudents: 'No linked students found for your account. Please contact the school.',
  resubmit: 'Resubmit',
  viewProfile: 'View Profile',
  lastUpdated: 'Last updated:',
  login1: 'Login',
  logout: 'Logout',
  accessibility: 'Accessibility',
  mainNavigation: 'Main navigation',
  aboutMOE: 'About MOE',
  moeStrategy: 'MOE Strategy',
  organizationStructure: 'Organization Structure',
  customerHappinessCharter: 'Customer Happiness Charter',
  uaeGovernmentCharter: 'UAE Government Charter',
  careers: 'Careers',
  helpAndSupport: 'Help & Support',
  contactUs: 'Contact Us',
  faqs: 'FAQs',
  digitalAccessibilityStatement: 'Digital Accessibility Statement',
  sitemap: 'Sitemap',
  references: 'References',
  guides: 'Guides',
  portals: 'Portals',
  legislations: 'Legislations',
  quickLinks: 'Quick Links',
  aboutThisWebsite: 'About This Website',
  copyright: 'Copyright',
  disclaimer: 'Disclaimer',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms And Conditions',
  followUsOn: 'Follow Us On:',
  tollFreeNumber: 'Toll Free:',
  allRightsReserved: 'All rights reserved',
  ministryOfEducation: 'Ministry of Education',
  metaTitle: 'Parent Portal - Ministry of Education',
  metaDescription:
    "A comprehensive parent portal for tracking your child's academic progress, attendance, and school communications.",
  appleWebAppTitle: 'Parent Portal',
  loadingChildData: "Loading child's information",
  downloadFile: 'Download file',
  removeFile: 'Remove file',
  uploadFile: 'Upload file',
  formatLabel: 'Format:',
  maxFileSizeLabel: 'Max file size:',
  fileSizeExceededError: 'File size exceeds the maximum allowed limit of {maxMb}MB',
  fileTypeInvalidError: 'Invalid file format. Allowed formats: {formats}',
  previousDocumentPrompt:
    'Dear user, you have previously attached a document of similar type. Would you like to reattach it?',
  viewDocument: 'View Document',
  useDocument: 'Use document',
  noThanks: 'No thanks',
  additionalInformation: 'Additional Information',
  parentCategoryCautionTitle: 'Important Notice',
  parentCategoryCautionText:
    'Please select the correct category, as it decides which documents are required. Ministry of Education employees and Imam Mosque positions need extra documents, while *Other* is for all other cases. This selection cannot be changed after submission.',
  parentCategoryLabel: "Child's parent is:",
  selectCategory: '-- Select category --',
  imamMosque: 'Imam Mosque',
  moeEmployee: 'MOE Employee',
  other: 'Other',
  continue: 'Continue',
  submit: 'Submit',
  back: 'Back',
  requiredDocuments: 'Required documents:',
  noRequiredDocuments: 'No required documents',
  additionalDocuments: 'Additional documents:',
  noAdditionalDocuments: 'No additional documents',
  fillRequiredDocumentsError: 'Please upload or select all required documents',
  documentsUpdateSuccess: 'Documents update request sent successfully',
  documentsUpdateFailed: 'Failed to send documents update request',
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    summary: 'Summary',
    myApplications: 'My Applications',
    messages: 'Messages',
    announcements: 'Announcements',
    calendar: 'Calendar',
    profile: 'Profile',
  },
  common: {
    close: 'Close',
    switchLanguage: 'Switch Language',
    english: 'English',
    arabic: 'Arabic',
    otherLanguages: 'Other languages',
    translationDisclaimer:
      'The list of “Other languages” listed above use Google Translate to create an automated translation of content for the purpose of display. Accuracy of automated content translation is not guaranteed.',
    search: 'Search',
    clear: 'Clear',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    send: 'Send',
    sendMessage: 'Send Message',
    today: 'Today',
    export: 'Export',
    month: 'Month',
    list: 'List',
    more: 'more',
    postedBy: 'Posted by',
    due: 'Due:',
    children: 'Children',
    attendanceRate: 'Attendance Rate',
    redirecting: 'Redirecting to dashboard...',
    loading: 'Loading...',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: "Welcome back! Here's what's happening with your children.",
    attendance: 'Attendance',
    latestGrade: 'Latest Grade',
    nextEvent: 'Next Event',
    recentAnnouncements: 'Recent Announcements',
    viewAll: 'View all',
    noRecentAnnouncements: 'No recent announcements',
    upcomingEvents: 'Upcoming Events',
    viewCalendar: 'View calendar',
    noUpcomingEvents: 'No upcoming events',
  },
  student: {
    viewDetails: 'View Details',
    personalInfo: 'Personal Information',
    academicInfo: 'Academic Information',
    contactInfo: 'Contact Information',
    nationality: 'Nationality',
    gender: 'Gender',
    birthDate: 'Birth Date',
    studentId: 'Student ID',
    grade: 'Grade',
    class: 'Class',
    male: 'Male',
    female: 'Female',
    age: 'Age',
    years: 'years',
  },
  announcements: {
    title: 'Announcements',
    subtitle: 'Stay updated with school and class announcements',
    searchPlaceholder: 'Search announcements...',
    allCategories: 'All Categories',
    allTags: 'All Tags',
    showing: 'Showing',
    of: 'of',
    announcementsLower: 'announcements',
    noResultsTitle: 'No announcements found',
    noResultsFilters: 'Try adjusting your filters to see more announcements',
    noResultsNone: 'There are no announcements at this time',
    clearFilters: 'Clear Filters',
    loadMore: 'Load More Announcements',
    categories: {
      all: 'All',
      school: 'School',
      class: 'Class',
      urgent: 'Urgent',
    },
  },
  messages: {
    title: 'Messages',
    subtitle: 'Communicate with teachers and school staff',
    newMessage: 'New Message',
    conversations: 'Conversations',
    searchPlaceholder: 'Search conversations...',
    noConversationsTitle: 'No conversations found',
    noConversationsDesc: 'Start a new conversation with a teacher',
    selectConversationTitle: 'Select a conversation',
    selectConversationDesc: 'Choose a conversation from the list to view messages',
    dialog: {
      newMessage: 'New Message',
      description: 'Start a conversation with a teacher or staff member.',
      to: 'To',
      subject: 'Subject',
      message: 'Message',
      selectTeacher: 'Select a teacher...',
      enterSubject: 'Enter subject...',
      typeMessage: 'Type your message...',
    },
  },
  calendar: {
    title: 'Calendar',
    subtitle: 'View upcoming events, exams, and important dates',
    month: 'Month',
    list: 'List',
    export: 'Export',
    today: 'Today',
    upcomingEvents: 'Upcoming Events',
    legend: {
      event: 'Event',
      exam: 'Exam',
      holiday: 'Holiday',
      meeting: 'Meeting',
    },
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    more: 'more',
    exportGoogle: 'Export to Google Calendar',
    exportOutlook: 'Export to Outlook',
  },
  profile: {
    title: 'Profile & Settings',
    subtitle: 'Manage your account information and preferences',
    personalInfo: 'Personal Information',
    edit: 'Edit',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    parentAccount: 'Parent Account',
    linkedChildren: 'Linked Children',
    linkedChildrenSubtitle: 'Children associated with your account',
    active: 'Active',
    notificationPreferences: 'Notification Preferences',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive updates via email',
    smsNotifications: 'SMS Notifications',
    smsNotificationsDesc: 'Receive updates via text message',
    pushNotifications: 'Push Notifications',
    pushNotificationsDesc: 'Receive browser notifications',
    accountActions: 'Account Actions',
    changePassword: 'Change Password',
    missingEmiratesIdTitle: 'Emirates ID Required',
    missingEmiratesIdMessage:
      'Your UAE Pass profile is missing your Emirates ID. Please update your UAE Pass profile with your Emirates ID to access all features and services.',
    updateUAEPass: 'Update UAE Pass Profile',
    privacySettings: 'Privacy Settings',
    downloadData: 'Download My Data',
    deactivateAccount: 'Deactivate Account',
    updatedSuccess: 'Profile updated successfully!',
  },
  login: {
    title: 'Parent Portal',
    subtitle: 'Sign in to your account',
    emailAddress: 'Email address',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot your password?',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    needHelp: 'Need help accessing your account?',
    contactSupport: 'Contact support',
    demoCreds: 'Demo credentials: any email and password will work',
  },
  footer: {
    rights: 'All rights reserved.',
    tagline: "Connecting parents with their children's education.",
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    support: 'Support',
    accessibility: 'Accessibility',
  },
  home: {
    redirecting: 'Redirecting to dashboard...',
  },
  child: {
    notFoundTitle: 'Child Not Found',
    notFoundDesc: "The child you're looking for doesn't exist or you don't have access to view their information.",
    goToDashboard: 'Go to Dashboard',
    breadcrumbChildren: 'Children',
    selectChild: 'Select child',
    yourChildren: 'Your Children',
    attendanceRate: 'Attendance Rate',
    tabs: {
      overview: 'Overview',
      attendance: 'Attendance',
      grades: 'Grades',
      assignments: 'Assignments',
    },
    attendanceSummary: 'Attendance Summary',
    present: 'Present',
    late: 'Late',
    absent: 'Absent',
    latestGrades: 'Latest Grades',
    upcomingAssignments: 'Upcoming Assignments',
    due: 'Due:',
    attendanceCalendar: 'Attendance Calendar',
    attendanceCalendarSubtitle: 'Monthly view of attendance records',
    attendanceLegend: {
      present: 'Present',
      late: 'Late',
      absent: 'Absent',
    },
    gradesAndTests: 'Grades & Tests',
    gradesAndTestsSubtitle: 'Recent test scores and assignments',
    downloading: 'Downloading...',
    downloadReportCard: 'Download Report Card',
    table: {
      subject: 'Subject',
      assignment: 'Assignment',
      grade: 'Grade',
      date: 'Date',
      teacher: 'Teacher',
    },
    assignmentsTitle: 'Assignments',
    assignmentsSubtitle: 'All assignments with due dates and status',
    updateInfo: {
      title: 'Update Student Information',
      intro: {
        init: 'Please review and update the contact, address, and transportation details for your child before signing the conduct charter.',
        edit: 'We need a few corrections before we can proceed. Update the details below and resubmit to continue to the conduct charter.',
      },
      modeLabel: {
        init: 'New request',
        edit: 'Needs revision',
      },
      contactSection: {
        title: 'Contact Numbers',
        description: 'Make sure we have an up-to-date mobile number in case the school needs to reach you urgently.',
        primaryLabel: 'Primary contact number (UAE Pass)',
        secondaryLabel: 'Additional contact number',
        addButton: 'Add another number',
        removeButton: 'Remove number',
      },
      addressSection: {
        title: 'Student Information',
        description:
          'Confirm that the address on file is still correct. If it changed, share the new details and upload a supporting document.',
        currentLabel: 'Current address',
        changeToggle: 'Has your address changed?',
        newAddressLabel: 'New address details',
        newAddressPlaceholder: 'Enter your updated residential address, including building, street, area, and emirate.',
        documentLabel: 'Upload proof of address (PDF)',
        documentHelper: 'Attach a recent utility bill, tenancy contract, or official document showing the new address.',
        summaryLabel: 'New address preview',
        summaryPending: 'Select an address to preview the full details here.',
        badge: {
          idle: 'Waiting',
          saving: 'Saving…',
          saved: 'Saved',
          error: 'Save failed',
        },
        summaryFields: {
          houseNumber: 'House / Building',
          streetName: 'Street',
          plotNumber: 'Plot',
          mainPlot: 'Main Plot',
          premises: 'Premises',
          latitude: 'Latitude',
          longitude: 'Longitude',
          areaName: 'Area',
          zoneName: 'Zone',
          regionName: 'Region',
          emirateName: 'Emirate',
        },
        summaryMissing: 'Not provided',
        autoSaveHint: 'New addresses save automatically once selected.',
        errorRetry: 'Try selecting the address again.',
      },
      transportationSection: {
        title: 'Student Transportation',
        description: 'Let us know how your child travels to and from school.',
        selectLabel: 'Transportation method',
        options: {
          car: 'Family car',
          bus: 'School bus',
          public: 'Public transport',
          other: 'Other',
        },
        otherLabel: 'Describe transportation',
      },
      validation: {
        primaryContact: 'Enter at least one contact number.',
        addressDetails: 'Provide the new address details.',
        document: 'Upload a supporting document for the new address.',
        transportation: 'Select a transportation method.',
        otherTransportation: 'Describe the transportation arrangement.',
      },
      submit: {
        continue: 'Continue',
        submitting: 'Preparing...',
        cancel: 'Back to child profile',
      },
      fileNameLabel: 'Selected file',
      fileReplace: 'Replace file',
      noFileSelected: 'No file selected',
    },

    // Added for child detail page localization
    loading: 'Loading...',
    error_loading_child_data: 'Error loading child data.',
    no_data_available_for_child: 'No data available for this child.',
    child_not_found: 'Child not found.',
    child_profile: 'Child Profile',
    basic_information: 'Basic Information',
    given_name: 'First Name',
    family_name: 'Family Name',
    username: 'Username',
    identifier: 'Emirate Id',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    status: 'Status',
    sourced_id: 'Sourced ID',
    last_modified: 'Last Modified',
    demographics_and_names: 'Demographics & Names',
    gender: 'Gender',
    birth_date: 'Birth Date',
    nationality_en: 'Nationality (EN)',
    nationality_ar: 'Nationality (AR)',
    arabic_name: 'Arabic Name',
    english_name: 'English Name',
    primary_address: 'Primary Address',
    country: 'Country',
    state: 'Emirate',
    city: 'City',
    zip_code: 'ZIP Code',
    po_box: 'PO Box',
    region: 'Region',
    sector: 'Sector',
    address_lines: 'Address Lines',
    road_number: 'Road Number',
    plot_id: 'Plot Id',
    plot_number: 'Plot Number',
    no_address_available: 'No address available',
    basic_info_subtitle: 'Personal identification and contact details',
    address_info_subtitle: 'Current residential address information',
    no_address_title: 'No Address Information',
    student_number: 'Student Number',
    religion: 'Religion',
    citizenship_status: 'Citizenship Status',
    middle_name: 'Middle Name',
    third_name: 'Third Name',
    fourth_name: 'Fourth Name',
    birth_place_city: 'Birth Place City',
    birth_place_country: 'Birth Place Country',
    nationality_info: 'Nationality & Citizenship',
    nationality_subtitle: 'Country of origin and citizenship details',
    birth_info: 'Birth Information',
    birth_info_subtitle: 'Date and place of birth details',
    parent_info: 'Parent/Guardian Information',
    parent_info_subtitle: 'Parent or guardian contact details',
    parent_name: 'Parent Name',
    parent_id: 'Parent ID',
    parent_email: 'Parent Email',
    parent_phone: 'Parent Phone',
    parent_enabled: 'Account Status',
    parent_enabled_yes: 'Active',
    parent_enabled_no: 'Inactive',
    no_parent_info: 'No parent information available',
  },
  pickLocation: {
    title: 'Pick Location',
    emirate: 'Emirate',
    region: 'Region',
    zone: 'Zone',
    area: 'Area',
    streetName: 'Street name / number',
    houseNumber: 'House number',
    requiredField: 'This field is required',
    loading: 'Loading...',
    noRegions: 'No regions available',
    noZones: 'No zones available',
    noAreas: 'No areas available',
  },
  admin: {
    title: 'Admin Panel',
    configuration: 'Configuration',
    verifyingAccess: 'Verifying admin access...',
    accessDenied: 'Access Denied',
    noPermission: 'You do not have permission to access this page.',
    redirecting: 'Redirecting to dashboard...',
    loggedInAs: 'Logged in as',
    backToPortal: 'Back to Portal',
    portal: 'Portal',
    navigation: {
      analytics: 'Analytics',
      analyticsDesc: 'System overview and statistics',
      students: 'Students',
      studentsDesc: 'Student directory and information',
      logs: 'Update Logs',
      logsDesc: 'Activity and update tracking',
      users: 'Admin Users',
      usersDesc: 'Manage admin access',
      periods: 'Update Periods',
      periodsDesc: 'Configure update windows',
      academicYear: 'Academic Year',
      academicYearDesc: 'Set active academic year',
      actions: 'Student Actions',
      actionsDesc: 'Manage student actions',
      resilience: 'API Resilience',
      resilienceDesc: 'Monitor system health & performance',
    },
    analytics: {
      title: 'System Analytics Overview',
      subtitle: 'Comprehensive view of system data, demographics, and activity',
    },
  },
  notifications: {
    title: 'Notifications',
    subtitle: 'Stay updated with important information about your children',
    unread: 'unread',
    total: 'total',
    new: 'NEW',
    read: 'Read',
    unreadStatus: 'Unread',
    markAllRead: 'Mark all read',
    markAllAsRead: 'Mark all as read',
    viewAll: 'View all notifications',
    seeAllActivity: 'See all incoming activity',
    noNotifications: 'No notifications',
    noNotificationsDesc: "You're all caught up! No new notifications at this time.",
    refresh: 'Refresh',
    loadMore: 'Load more',
    student: 'Student',
    status: 'Status',
    filters: 'Filters',
    filterByStatus: 'Filter by status',
    filterByType: 'Filter by type',
    all: 'All',
    allTypes: 'All Types',
    showing: 'Showing',
    of: 'of',
    // Notification types
    types: {
      info: 'Information',
      success: 'Success',
      warning: 'Warning',
      error: 'Error',
      enrollment: 'Enrollment',
      update: 'Update',
      conduct: 'Conduct',
      announcement: 'Announcement',
      StatusChange: 'Status Change',
      AddressUpdate: 'Address Update',
      ContactUpdate: 'Contact Update',
      TransportationUpdate: 'Transportation Update',
      DataUpdate: 'Data Update',
    },
    // Time formats
    time: {
      justNow: 'Just now',
      minutesAgo: 'minutes ago',
      hoursAgo: 'hours ago',
      daysAgo: 'days ago',
      weeksAgo: 'weeks ago',
      monthsAgo: 'months ago',
    },
    // Actions
    actions: {
      markAsRead: 'Mark as read',
      markAsUnread: 'Mark as unread',
      delete: 'Delete',
      viewDetails: 'View details',
    },
    // Toast notifications
    toast: {
      newNotification: 'New Notification',
      newNotifications: 'New Notifications',
      youHave: 'You have',
      new: 'new',
      notification: 'notification',
      notifications: 'notifications',
    },
  },
  parentConduct: {
    title: 'Partnership Charter between School and Parent',
    subtitle: 'Ministry of Education - United Arab Emirates',
    backButton: 'Back',
    progress: 'Progress',
    loading: 'Loading charter data...',
    noStudentId: 'Cannot display page without student identifier.',
    errorLoading: 'Failed to load required data.',
    steps: {
      schoolInfo: 'School Information',
      parentInfo: 'Parent Information',
      terms: 'Charter Terms',
      signature: 'Signature',
    },
    progressLabels: {
      current: 'Step:',
      of: 'of',
    },
    introduction: {
      title: 'Introduction',
      paragraph1:
        'Within the framework of activating effective partnership between the school and the parent and enhancing their role in supporting the achievement and behavior of our students, this charter aims to clarify the mutual roles and responsibilities between the two parties to ensure a safe and stimulating educational environment.',
      paragraph2:
        "The parent's signature on this charter is an acknowledgment of having read and understood its provisions and a commitment to abide by them. It also represents an agreement to constructive cooperation with the school to achieve distinguished educational and behavioral outcomes for our children.",
    },
    schoolSection: {
      title: 'School Information',
      schoolName: 'School Name',
      schoolId: 'School Identifier',
      address: 'Address',
      phone: 'Phone Number',
      email: 'Email Address',
      schoolYear: 'School Year',
      gradeClass: 'Grade and Class',
      studentName: 'Student Name',
      nationalId: 'Emirates ID',
      studentSystemId: 'Student System ID',
      routeId: 'Route ID',
    },
    parentSection: {
      title: 'Parent & Student Information',
      parentData: 'Parent Data',
      parentName: 'Parent Name',
      parentNationalId: 'Emirates ID',
      parentAddress: 'Address',
      contactNumber: 'Contact Number',
      parentEmail: 'Email Address',
      linkedStudentData: 'Linked Student Data',
      studentFullName: 'Student Full Name',
    },
    termsSection: {
      validityTitle: 'Duration and Validity of This Charter:',
      validityText: 'One academic year starting from the date of acknowledgment of the charter.',
      schoolCommitmentsTitle: 'School Commitments',
      parentCommitmentsTitle: 'Parent Commitments',
      categories: {
        basicRequirements: 'Basic Requirements',
        behaviorDiscipline: 'Behavior and Discipline',
        qualityOfLife: 'Student Quality of Life / Health and Safety',
        citizenship: 'Positive Citizenship and National Identity',
        academicAchievement: 'Academic Achievement and Educational Programs',
        assessment: 'Assessment and Examinations',
        activities: 'Activities and Student Care',
        transportation: 'Transportation',
        uniform: 'School Uniform',
        publicProperty: 'School Public Property',
        behavior: 'Behavior',
      },
    },
    signatureSection: {
      title: 'Signature and Approval',
      summaryTitle: 'Data Summary',
      school: 'School:',
      student: 'Student:',
      parent: 'Parent:',
      grade: 'Grade:',
      parentDeclaration: 'Parent Declaration:',
      declarationText:
        'I acknowledge that I have read all provisions of the partnership charter between the school and parent, understood its content completely, and commit to all the aforementioned terms and conditions, and to cooperate with the school to ensure the best interest of my child.',
      ministryStamp: 'Ministry of Education',
      approved: 'Approved',
      date: 'Date',
    },
    navigation: {
      previous: 'Previous',
      next: 'Next',
      close: 'Close',
    },
    placeholder: '—',
    conductTerms: {
      validityPeriod: 'One academic year starting from the date of acknowledgment of the charter.',
      schoolCommitments: {
        title: 'School Commitments',
        sections: [
          {
            title: 'Basic Requirements',
            items: [
              'Ensure a school environment based on equality and equal opportunities for all students.',
              "Inform parents of assessment results and approved procedures to improve their children's performance.",
              "Inform parents about their children's positive behaviors, as well as their behavioral violations.",
              'Inform parents of students with determination about their rights and duties and provide a rich and supportive educational environment and equipped and modified facilities that suit their needs.',
              'Ensure a safe and inclusive school environment that ensures student safety.',
              'Establish guidelines for student health and raise awareness of the importance of adopting healthy habits and lifestyles.',
              'Build effective communication channels with parents to inform them of updates to instructions, procedures or regulations and share important information with them as well as keep them informed of school news.',
              'Transparency and fairness in implementing procedures and policies while maintaining the confidentiality of student information and data.',
            ],
          },
          {
            title: 'Behavior and Discipline',
            items: [
              'Implement Ministerial Decision No. (851) of 2018 on the regulations for managing student behavior in public education institutions with fairness and transparency, while raising awareness among students and their parents of the consequences of violations.',
              'Monitor student attendance and departure in accordance with official schedules and procedural guides, and take appropriate action when there is delay or unjustified absence.',
              'Commit to respecting parents and building effective communication channels with them to inform them of updates related to instructions, procedures and regulations, share important information with them, and regularly inform them of school news.',
            ],
          },
          {
            title: 'Student Quality of Life / Health and Safety',
            items: [
              'Provide a healthy and safe school environment that complies with safety and security standards.',
              'Organize awareness programs to promote personal hygiene and general health for students.',
              "Keep students' medical records and coordinate with parents regarding any health cases.",
            ],
          },
          {
            title: 'Positive Citizenship and National Identity',
            items: [
              'Organize activities to enhance the values of good citizenship and social responsibility among students.',
              'Instill pride in national identity and human values such as respect, tolerance and coexistence through various activities.',
            ],
          },
          {
            title: 'Academic Achievement and Educational Programs',
            items: [
              "Update student data periodically in the Ministry's systems.",
              "Monitor student academic performance regularly and involve parents in assessment results and approved procedures to improve their children's performance.",
              'Prepare and implement individualized educational plans for students with determination in cooperation with their families.',
              'Transparency and fairness in implementing procedures and policies while maintaining the confidentiality of student information and data.',
            ],
          },
          {
            title: 'Assessment and Examinations',
            items: [
              'Implement the approved assessment policy and comply with official schedules for assessments and examinations.',
              'Continuously monitor student results and provide feedback.',
              'Ensure the readiness of the examination environment and provide the necessary tools and devices.',
              'Prevent any practices related to cheating or leaking questions, and take deterrent measures when they occur.',
            ],
          },
          {
            title: 'Activities and Student Care',
            items: [
              'Provide diverse classroom and extracurricular activities to discover and develop student skills.',
              'Encourage students to participate in national initiatives, volunteer programs and community service.',
            ],
          },
          {
            title: 'Transportation',
            items: [
              'Supervise school transportation services and ensure compliance with safety standards.',
              'Monitor student behavior on buses and take educational measures when violations occur.',
            ],
          },
          {
            title: 'School Uniform',
            items: [
              "Raise parents' awareness of the school uniform guide and official sales channels for the unified school uniform.",
              "Monitor students' compliance with the uniform and appropriate appearance during school hours.",
            ],
          },
          {
            title: 'School Public Property',
            items: [
              "Enhance students' awareness of the importance of preserving public property and school facilities.",
              "Monitor students' use of facilities and ensure their protection from tampering or vandalism.",
              'Apply appropriate procedures in case of damage, in coordination with parents.',
            ],
          },
        ],
      },
      parentCommitments: {
        title: 'Parent Commitments',
        sections: [
          {
            title: 'Behavior',
            items: [
              'Encourage their children to adopt moral and educational values, promote positive behavior, motivate them to learn and abide by laws and respect all school staff.',
              'Review the approved student behavior management regulations in federal government educational institutions, and raise awareness and guide their children on the necessity of adhering to them and the consequences of violating them.',
              'Urge students to adhere to attendance and departure schedules and be aware of the consequences of being late and not arriving early to school.',
              'Urge students to adhere to attendance and departure schedules and be aware of the consequences of being absent without an excuse.',
              "Adhere to the school's instructions when coming to request a service, discuss a problem, or settle any disputes.",
            ],
          },
          {
            title: 'Student Quality of Life / Health and Safety',
            items: [
              'Provide a healthy environment that includes healthy food standards and types of food and drink allowed at school.',
              'Provide sufficient time for sleep, relaxation and psychological comfort for their children in a stable family environment.',
              'Raise awareness about personal hygiene for children.',
              'Encourage physical activities through movement and play.',
              'Provide assistance and support to children in solving personal, emotional and academic problems.',
              'Provide all medical reports related to the student and his medical history to the school administration.',
              'Active participation by answering questionnaires sent by the Ministry or the school.',
            ],
          },
          {
            title: 'Positive Citizenship and National Identity',
            items: [
              'Commit to promoting good citizenship and social responsibility among children and motivate them to carry out national duties and responsibilities, and encourage them to actively participate in social life, charitable and voluntary work.',
              'Commit to motivating children to take pride in their national identity and to have basic moral and human values such as respect, tolerance and coexistence between citizens and residents.',
            ],
          },
          {
            title: 'Academic Achievement and Educational Programs',
            items: [
              "Update children's data according to the procedures, conditions and provisions approved in the Ministry.",
              'The parent commits to providing a computer device according to the procedures and specifications approved by the Ministry, while complying with the standards and conditions for the computer usage policy.',
              "Communicate with the school administration to follow up on their children's performance in school and provide support to them.",
              'Motivate children to study, set clear goals for them, guide them, and show the importance of education in their future lives.',
              'Prepare the family atmosphere and allocate sufficient time for studying, preparing and preparing for examinations while ensuring sufficient time for rest.',
              'Follow up on students with determination in performing their duties according to the approved individualized educational plan.',
            ],
          },
          {
            title: 'Assessment and Examinations',
            items: [
              'Review the approved assessment policy and comply with what is stated in it and adhere to the specified assessment and examination schedules.',
              "Continuously follow up on children's assessments and examinations to raise their performance level throughout the school year.",
              'Ensure children are ready to take the exam (bring necessary tools, charge computer/tablet).',
              'Raise student awareness to comply with exam rules and regulations and not to cheat or leak exam questions or participate in them in any way.',
              'Emphasize to the student not to use mobile phones or other electronic devices in the examination hall.',
            ],
          },
          {
            title: 'Activities and Student Care',
            items: [
              'Encourage children to participate in classroom and extracurricular activities, events, national initiatives, volunteer work and community service to acquire and develop general skills.',
            ],
          },
          {
            title: 'Transportation',
            items: [
              'Adhere to following all safety conditions and behavioral rules and school transportation schedules adopted by the school.',
              'Direct children to adhere to positive behavior on school buses.',
              'Commit to paying for any damage caused by his children on the school bus.',
            ],
          },
          {
            title: 'School Uniform',
            items: [
              'Commit to having children wear the unified school uniform approved by the Ministry.',
              'Children adhere to a decent and elegant appearance during school hours.',
            ],
          },
          {
            title: 'School Public Property',
            items: [
              'Teach children the value of preserving public property and its importance, and motivate them to preserve it.',
              'Direct children not to cause any intentional or unintentional damage to public property at school.',
              'Pledge to compensate for damage resulting from tampering with property and facilities that the student may cause at school or on transportation.',
            ],
          },
          {
            title: 'Tuition Fees: (For Non-Citizen Students)',
            items: [
              "Commit to paying the tuition fees due for the children in full at the beginning of the academic year or by installment in three payments to be paid before the start of each semester in accordance with the eligibility conditions approved by the Ministry. In case of non-compliance, the Ministry has the right to withhold interim and final results, suspend school services for the student, and cancel the student's enrollment for the following academic year in accordance with the approved regulations. The guardian bears all consequences regarding the student's right to education.",
            ],
          },
        ],
      },
    },
  },
};

export type Messages = typeof en;
